export const environment: {
  production: boolean,
  name: string,
  hmr: boolean,
  URL_ME?: string
} = {
  production: false,
  name: 'prod',
  hmr: false,
};


export const API_LOCAL = `https://bfkts3jaswinpvxy12014.cleavr.one`
export const API_BIO_URL = `${API_LOCAL}/api`;

export const API_HOST = `http://sigalerta.solved.eco.br:9080`;
export const API_HOST_PATH = `alerta-server`;
export const API_BASE_URL = `${API_HOST}/${API_HOST_PATH}/api`;
export const GEOSERVER_URL = "http://sigalerta.solved.eco.br:9090/geoserver";
export const GEE_IMAGE_API_BASEURL = 'http://sigalerta.solved.eco.br:8001';

export const SEMAMT_GEOSERVER_URL = "https://geo.sema.mt.gov.br/geoserver";
export const SEMAMT_GEOSERVER_WORKSPACE = 'Sema_Alertas'
export const SEMAMT_GEOSERVER_AUTHKEY = "44cb205d-a7ab-482b-a5b1-98d4efd5c3b9";
export const PLANET_API_KEY = 'PLAK77ea22a9cf8b4a8b99f5a42bf42eb628';

